import { render } from "./TabParents.vue?vue&type=template&id=37f19d8f&ts=true"
import script from "./TabParents.vue?vue&type=script&lang=ts"
export * from "./TabParents.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__